module.exports = __webpack_public_path__ + "static/img/840-1.2dfaab7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/psLock/840/840-1.jpg
// module id = ctfl
// module chunks = 0